import React from 'react';
import { Button, ChevronLeftIcon } from '../ui';
import { cn } from '../../lib/utils';

type FormBackButtonProps = {
  onClick: () => void;
  label?: string;
  className?: string;
};

/** Matches InvoiceForm / accounting edit: ghost icon-only back control. */
export const FormBackButton: React.FC<FormBackButtonProps> = ({
  onClick,
  label = 'Back',
  className,
}) => {
  return (
    <div className={cn('flex-shrink-0', className)}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={onClick}
        aria-label={label}
        title={label}
      >
        <ChevronLeftIcon className="h-5 w-5" />
      </Button>
    </div>
  );
};
